import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseCrudService } from 'projects/ProjetoBaseAngular/domain/services/base-crud.service';
import { TipoParceiroModel } from '../models';

@Injectable({
  providedIn: 'root'
})
export class TipoParceiroService extends BaseCrudService<TipoParceiroModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'TipoParceiro';
  }

  getAll(): Observable<TipoParceiroModel[]> {
    return this
      .httpClient
      .get<TipoParceiroModel>(`${this.getApiUrl()}${this.getController()}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
